import {Tooltip} from "../../../../components/Tooltip";
import React, {useState} from "react";
import {duplicateIndicator} from "../../../../services/Indicators.service";
import {toast} from "react-toastify";
import {swalQuestion} from "../../../../components/Swal";
import {useQueryClient} from "react-query";

export const DuplicateIndicator = ({indicatorId, code}) => {

    const [loading, setLoading] = useState(false)
    const queryClient = useQueryClient()

    const duplicate = async () => {
        setLoading(true)
        try {
            const response = await duplicateIndicator(indicatorId)
            queryClient.invalidateQueries(['indicators_list'])
            toast.success(`Indicador duplicado com sucesso! ID: ${response.id}`)

        } catch (e) {
            toast.error('Erro ao duplicar indicador!')
        }
        setLoading(false)
    }

    const handleDuplicate = async () => {
        swalQuestion(`Deseja duplicar o indicador <b>${code}</b>?`)
            .then((result) => {
                if (result.isConfirmed) {
                    duplicate()
                }
            })
    }


    return (
        <Tooltip label="Duplicar indicador">
            <button className="btn btn-primary btn-sm" type="button"
                    onClick={() => handleDuplicate()}>
                {loading ? <div className="spinner-border spinner-border-sm" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div> : <i className="bi bi-copy"/>}

            </button>
        </Tooltip>
    )
}